<template>
    <div class="report">
        <div class="title-row">
            <span class="count">{{ count.total | dots }}</span>
            <span class="report-title">{{ title }}</span>
            <i class="icon fa" :class="{ [icon]: true }"></i>
        </div>
        <div class="specifications-row">
            <div class="specification">
                <span class="count">{{ count.spontaneous | dots }}</span>
                <span class="report-title">{{
                    $t('talk.feedback.spontaneous')
                }}</span>
            </div>
            <div class="specification">
                <span class="count">{{ count.requested | dots }}</span>
                <span class="report-title">{{
                    $t('talk.feedback.requested')
                }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Report',
    props: {
        title: String,
        count: String | Number,
        icon: String,
    },
    filters: {
        dots(value) {
            if (value === null || value === undefined) {
                return '-'
            }
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        },
    },
}
</script>

<style lang="sass" scoped>
@import './style'
</style>
